export default __webpack_public_path__ + "b632cfbb7a5a0817c31416865a0e1b3e.png";